module.exports = __webpack_public_path__ + "res/img/yrsq.5144313c.png";